import { IconBallAmericanFootball, IconGolf, IconList } from '@tabler/icons-react';
import { Sport } from '@betterpool/api-types/contests-service';

import dt from '~/testing';

type ContestRowIconProps = {
  sport: Sport;
  className?: string;
};

function ContestIcon({ sport, className }: ContestRowIconProps) {
  switch (sport) {
    case Sport.GOLF:
      return (
        <IconGolf
          data-test-id={dt.contestDetail.section.about.golfIcon}
          className={className}
          stroke={2}
          size={20}
        />
      );
    case Sport.FOOTBALL:
      return (
        <IconBallAmericanFootball
          data-test-id={dt.contestDetail.section.about.footballIcon}
          className={className}
          stroke={2}
          size={20}
        />
      );
    default:
      return (
        <IconList
          data-test-id={dt.contestDetail.section.about.unknownIcon}
          className={className}
          stroke={2}
          size={20}
        />
      );
  }
}

export default ContestIcon;
